import { DestroyRef, inject, Injectable, InjectionToken } from '@angular/core';
import { distinctUntilChanged, Observable } from 'rxjs';
import { BuilderWeatherCache, type BuilderWeatherRequest, type BuilderWeatherTransport } from './weather-cache';
import type { BuilderWeatherSnapshot } from './weather';
import { createOpenMeteoWeatherTransport } from './weather-transport';

/** Override at application setup to use a backend proxy without changing page configuration. */
export const BUILDER_WEATHER_TRANSPORT = new InjectionToken<BuilderWeatherTransport>('Builder weather transport', {
  providedIn: 'root',
  factory: () => createOpenMeteoWeatherTransport(),
});

@Injectable({ providedIn: 'root' })
export class BuilderWeatherService {
  private readonly cache = new BuilderWeatherCache(inject(BUILDER_WEATHER_TRANSPORT));

  public constructor() {
    inject(DestroyRef).onDestroy(() => this.cache.destroy());
  }

  public observe(request: BuilderWeatherRequest): Observable<BuilderWeatherSnapshot | undefined> {
    return new Observable<BuilderWeatherSnapshot | undefined>(subscriber =>
      this.cache.subscribe(request, snapshot => subscriber.next(snapshot)),
    ).pipe(distinctUntilChanged());
  }
}
